// extracted by mini-css-extract-plugin
export default {"products":"uw-z","card":"vw-z","oosMessaging":"ww-z"};